import { CSSProperties, ReactNode } from 'react'
import clsx from 'clsx'

import styles from './Steps.module.scss'

interface OrderStepsProps extends React.HTMLAttributes<HTMLDivElement> {
  steps: Array<string | ReactNode>
  maxWidth?: number
}

export default function OrderSteps({
  steps,
  maxWidth = 1000,
  className,
  style,
  ...props
}: OrderStepsProps) {
  return (
    <div
      className={clsx(styles.wrapper, className)}
      style={
        {
          '--steps-count': steps.length,
          '--steps-gaps-count': steps.length - 1,
          '--steps-max-width': `${maxWidth}px`,
          ...style
        } as CSSProperties
      }
      {...props}
    >
      {steps.map((step, index) => (
        <div key={index} className={styles.step}>
          <div className={styles.stepNumber}>{index + 1}</div>
          <div className={styles.stepDescription}>{step}</div>
          {index < steps.length - 1 && (
            <>
              <div className={styles.arrowBase} />
              <div className={styles.arrowMobile} />
            </>
          )}
        </div>
      ))}
    </div>
  )
}
